import { Flex } from "components/LEGACY/styled-components/Flex"
import PasswordResetForm from "components/utils/PasswordResetForm"
import PatternPageContainer from "components/utils/PatternPageContainer"
import gastromiaLogo from "images/gastromia_logo.png"
import Image from "next/image"
import Link from "next/link"

const ResetPassword = () => {
  return (
    <>
      <style jsx>{`
        .container {
          display: grid;
          justify-items: center;
          position: relative;
          grid-gap: 10px;
        }
        .linkContainer {
          width: 100%;
          display: flex;
          justify-content: space-between;
          padding: 0 10px;
        }
      `}</style>
      <PatternPageContainer light>
        <Flex style={{ height: "100%" }} justifyCenter alignCenter>
          <div className="container">
            <Image src={gastromiaLogo} alt={"GASTROMIA logo"} className="tw-object-contain" height={70} width={300} />

            <h1 style={{ color: "black" }}>Passwort zurücksetzen</h1>

            <PasswordResetForm />
            <div className="linkContainer">
              <Link href="/login">Stattdessen anmelden</Link>
            </div>

            <hr />
          </div>
        </Flex>
      </PatternPageContainer>
    </>
  )
}

export default ResetPassword
